// extracted by mini-css-extract-plugin
export default {"fullPageContainer":"full-page-container_fullPageContainer__pO4G6"};